module.exports = __webpack_public_path__ + "static/media/ifps2.e6cf7f01.svg";